import React from "react";
import { Box } from "../utils";

export type StepComponent = {
  stepNo: number;
  component: React.ReactNode;
};

export type StepperNavigationProps = {
  currentStep: number;
  steps: StepComponent[];
  className?: string;
};

export const StepperNavigation: React.FC<StepperNavigationProps> = ({
  currentStep,
  steps,
  className = "",
}) => {
  const activeStep = steps.find((step) => step.stepNo === currentStep);

  return (
    <Box className={`w-full h-full ${className}`}>
      {activeStep?.component || null}
    </Box>
  );
};
